<mat-card class="content-block" cdkDrag>
  <div class="drag-handle" cdkDragHandle>
    <mat-icon>drag_indicator</mat-icon>
  </div>

  <mat-card-header>
    <mat-card-title class="block-title">
      {{ 'TEMPLATES.EDITOR.BLOCK_TYPES.' + block.type | translate }}
    </mat-card-title>
    <button mat-icon-button class="remove-block-button" (click)="removeContentBlock(); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content>
    @if (showsStyleSettings) {
      <div class="style-settings">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'TEMPLATES.EDITOR.LEVEL_OF_DETAIL' | translate }}</mat-label>
          <mat-select [(value)]="block.levelOfDetail" (selectionChange)="markAsChanged()">
            <mat-option [value]="MinutesVerboseness.CONCISE">{{ 'TEMPLATES.EDITOR.CONCISE' | translate }}</mat-option>
            <mat-option [value]="MinutesVerboseness.DETAILED">{{ 'TEMPLATES.EDITOR.DETAILED' | translate }}</mat-option>
            <mat-option [value]="MinutesVerboseness.EXHAUSTIVE">{{ 'TEMPLATES.EDITOR.EXHAUSTIVE' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'TEMPLATES.EDITOR.ATTRIBUTION' | translate }}</mat-label>
          <mat-select [(value)]="block.anonymization" (selectionChange)="markAsChanged()">
            <mat-option [value]="MinutesAnonymization.NONE">{{ 'TEMPLATES.EDITOR.NAME_NAMES' | translate }}</mat-option>
            <mat-option [value]="MinutesAnonymization.ALL">{{ 'TEMPLATES.EDITOR.ANONYMIZE' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (block.type === TemplateContentBlockType.FIXED_TEXT) {
      <app-formatted-text-editor
        [initialContent]="parseJsonStringToProseMirrorDoc(block.data.formattedTextBlock.content)"
        [allowPlaceholders]="false"
        (contentChange)="changeFormattedTextBlockContent(block.data.formattedTextBlock, $event)"
      ></app-formatted-text-editor>
    } @else if (block.type === TemplateContentBlockType.VARIABLE_TEXT) {
      <app-formatted-text-editor
        [initialContent]="parseJsonStringToProseMirrorDoc(block.data.formattedTextBlock.content)"
        (contentChange)="changeFormattedTextBlockContent(block.data.formattedTextBlock, $event)"
      ></app-formatted-text-editor>
    } @else if (block.type === TemplateContentBlockType.DISCUSSION_SUMMARY) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'TEMPLATES.EDITOR.SYSTEM_GUIDANCE' | translate }}</mat-label>
        <textarea matInput [id]="'textarea-block-' + block.id" [(ngModel)]="block.data.guidance" (ngModelChange)="markAsChanged()" rows="4"></textarea>
      </mat-form-field>
    } @else if (block.type === TemplateContentBlockType.KEY_MESSAGES) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'TEMPLATES.EDITOR.SYSTEM_GUIDANCE' | translate }}</mat-label>
        <textarea matInput [id]="'textarea-block-' + block.id" [(ngModel)]="block.data.guidance" (ngModelChange)="markAsChanged()" rows="4"></textarea>
      </mat-form-field>
    } @else if (block.type === TemplateContentBlockType.DISCUSSION_CHALLENGE) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'TEMPLATES.EDITOR.SYSTEM_GUIDANCE' | translate }}</mat-label>
        <textarea matInput [id]="'textarea-block-' + block.id" [(ngModel)]="block.data.guidance" (ngModelChange)="markAsChanged()" rows="4"></textarea>
      </mat-form-field>
    } @else if (block.type === TemplateContentBlockType.BINARY) {
      <div class="binary-options-container">
        <h5>{{ 'TEMPLATES.EDITOR.BINARY_OPTIONS' | translate }}</h5>
        @for (textBlock of block.data.formattedTextBlocks; track $index) {
          <div class="binary-option">
            <app-formatted-text-editor
              [initialContent]="parseJsonStringToProseMirrorDoc(textBlock.content)"
              [autoFocus]="$index === 0"
              (contentChange)="changeFormattedTextBlockContent(textBlock, $event)"
            ></app-formatted-text-editor>
            <button mat-icon-button color="warn" (click)="removeFormattedTextBlock(textBlock.index)" [disabled]="block.data.formattedTextBlocks.length <= 2">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
        <button class="add-option-button" mat-stroked-button (click)="addFormattedTextBlock()">
          <mat-icon>add</mat-icon>
          {{ 'TEMPLATES.EDITOR.ADD_OPTION' | translate }}
        </button>
      </div>
    }

    @if (showsSourceSettings) {
      <div class="sources-section">
        <div class="sources-header">
          <label
            >{{ 'TEMPLATES.EDITOR.SOURCES' | translate }}
            @if (totalNumberOfPagesOfSources > 0 || totalSizeOfSources > 0) {
              (
              @if (totalNumberOfPagesOfSources > 0) {
                {{ totalNumberOfPagesOfSources }} / {{ maximumTotalPagesForContentBlock }} {{ 'TEMPLATES.EDITOR.PAGES' | translate }}
              }
              @if (totalNumberOfPagesOfSources > 0 && totalSizeOfSources > 0) {
                -
              }
              @if (totalSizeOfSources > 0) {
                {{ totalSizeOfSources | filesize }} / {{ maximumTotalSourceSizeForContentBlock | filesize }}
              }
              )
            }
          </label>
          @if (allowSourceEditing) {
            <div class="source-actions">
              <button mat-icon-button [matMenuTriggerFor]="sourceMenu" class="add-source-button">
                <mat-icon>add</mat-icon>
              </button>
              <mat-menu #sourceMenu="matMenu" class="scrollable-source-menu">
                @if (!blockHasTranscriptSource) {
                  <button mat-menu-item (click)="addSource(TemplateContentBlockSourceType.TRANSCRIPT, null)">
                    <mat-icon>record_voice_over</mat-icon>
                    <span>{{ 'TEMPLATES.EDITOR.SOURCE_TYPES.TRANSCRIPT' | translate }}</span>
                  </button>
                }
                @if (allowFileUpload) {
                  <button mat-menu-item (click)="triggerFileUpload()">
                    <mat-icon>upload_file</mat-icon>
                    <span>{{ 'TEMPLATES.EDITOR.ATTACH_NEW_SOURCE' | translate }}</span>
                  </button>
                  <input type="file" [id]="'file-upload-' + block.id" accept=".pdf" (change)="onFileSelected($event)" style="display: none" />
                }
                @for (resource of unusedAvailableResourcesForContentBlock; track resource.index) {
                  <button
                    mat-menu-item
                    (click)="canAddResource(resource) && addSource(TemplateContentBlockSourceType.FILE_UPLOAD, resource)"
                    [class.disabled-menu-item]="!canAddResource(resource)"
                  >
                    <mat-icon>description</mat-icon>
                    <span class="resource-menu-item-content" [matTooltip]="resource.fileName">
                      <span class="resource-filename">{{ truncateFileNameFromMiddle(resource.fileName, 30) }}</span>
                      <span class="resource-metadata">
                        (
                        @if (resource.metadata !== null) {
                          {{ resource.metadata.numberOfPages | pageCount }} ·
                        }
                        {{ resource.size | filesize }})
                      </span>
                      @if (!canAddResource(resource)) {
                        <mat-icon class="info-icon" [matTooltip]="getResourceDisabledTooltip(resource)" (click)="$event.stopPropagation()">info</mat-icon>
                      }
                    </span>
                  </button>
                }
              </mat-menu>
            </div>
          }
        </div>

        @if (nonOrphanSources.length > 0) {
          <mat-chip-set>
            @for (source of nonOrphanSources; track $index) {
              @if (source.type === TemplateContentBlockSourceType.TRANSCRIPT) {
                <mat-chip>
                  <mat-icon matChipAvatar>record_voice_over</mat-icon>
                  {{ 'TEMPLATES.EDITOR.SOURCE_TYPES.TRANSCRIPT' | translate }}
                  @if (allowSourceEditing && canRemoveTranscriptSource) {
                    <button matChipRemove (click)="removeSource(source)">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip>
              } @else if (source.type === TemplateContentBlockSourceType.FILE_UPLOAD) {
                @if (source.isPending) {
                  <mat-chip class="pending-chip file-upload-chip" [matTooltip]="source.fileName">
                    <mat-icon matChipAvatar class="spinning-icon">sync</mat-icon>
                    <span class="file-name">{{ truncateFileNameFromMiddle(source.fileName) }}</span>
                    <span class="file-metadata">({{ 'TEMPLATES.EDITOR.UPLOADING' | translate }})</span>
                  </mat-chip>
                } @else {
                  <mat-chip class="file-upload-chip" [matTooltip]="source.callResource!.fileName">
                    <mat-icon matChipAvatar>description</mat-icon>
                    <span class="file-name">{{ truncateFileNameFromMiddle(source.callResource!.fileName) }}</span>
                    <span class="file-metadata">
                      @if (source.callResource!.metadata !== null) {
                        ({{ source.callResource!.metadata.numberOfPages | pageCount }} ·
                      }
                      @if (source.callResource!.metadata === null) {
                        (
                      }
                      {{ source.callResource!.size | filesize }})
                    </span>
                    @if (allowSourceEditing) {
                      <button matChipRemove (click)="removeSource(source)">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    }
                  </mat-chip>
                }
              }
            }
          </mat-chip-set>
        } @else if (displayMissingSourceWarning) {
          <div class="missing-source-warning">
            <mat-icon>info</mat-icon>
            <span>{{ 'TEMPLATES.EDITOR.MISSING_SOURCE_WARNING' | translate }}</span>
          </div>
        }
      </div>
    }
  </mat-card-content>

  <div class="cdk-drag-placeholder"></div>
</mat-card>
